module.exports = __webpack_public_path__ + "img/MTCIMEDI.f0ae38cc.svg";